import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { filter, first, tap } from 'rxjs/operators';
import { LoadRoles } from './state/role.action';
import { RoleState } from './state/role.state';

@Injectable()
export class RoleResolver {
  rolesLoaded$: Observable<boolean> = this.store.select(RoleState.rolesLoaded);

  constructor(private store: Store) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> {
    return this.rolesLoaded$.pipe(
      tap((rolesLoaded) => {
        if (!rolesLoaded) {
          this.store.dispatch(new LoadRoles());
        }
      }),
      filter((rolesLoaded) => rolesLoaded),
      first()
    );
  }
}
